import { useEffect, useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'
import { dbConsoleService } from '@/services/dbConsole'
import { useNotificationStore } from '@/store/notificationStore'
import { exportApprovalNotifications } from '@/utils/exportApprovalAlerts'

/**
 * Feeds the notification bell with Database Console export approvals: a request
 * that names the signed-in person as the second approver, and the decision on
 * one they raised. A reader without Database Console access gets a refusal,
 * which is read as "nothing for me" (no retry, no noise). Renders nothing.
 */
export default function ExportApprovalSync() {
  const syncLive = useNotificationStore((state) => state.syncLive)
  const list = useQuery({
    queryKey: ['db-console', 'export-requests', 'bell'],
    queryFn: dbConsoleService.listExportRequests,
    refetchInterval: 30_000,
    refetchIntervalInBackground: true,
    retry: false,
    staleTime: 15_000,
  })
  const items = useMemo(
    () => (list.data ? exportApprovalNotifications(list.data.requests, list.data.viewerEmail) : []),
    [list.data],
  )
  useEffect(() => {
    syncLive('system', items)
  }, [items, syncLive])
  return null
}
